const leagueLogoMap: Record<string, string> = {
  nfl: 'https://a.espncdn.com/i/teamlogos/leagues/500/nfl.png',
  nba: 'https://a.espncdn.com/i/teamlogos/leagues/500/nba.png',
  mlb: 'https://a.espncdn.com/i/teamlogos/leagues/500/mlb.png',
  nhl: 'https://a.espncdn.com/i/teamlogos/leagues/500/nhl.png',
  wnba: 'https://a.espncdn.com/i/teamlogos/leagues/500/wnba.png',
  mls: 'https://a.espncdn.com/i/teamlogos/leagues/500/mls.png',
  // NCAA / Collegiate
  ncaa: 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  ncaaf: 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  'college-football': 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  'mens-college-basketball': 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  'womens-college-basketball': 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  'college-baseball': 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
  'college-softball': 'https://a.espncdn.com/i/teamlogos/ncaa/500/ncaa.png',
};

const leagueColorMap: Record<string, string> = {
  nfl: '#013369',
  nba: '#1D428A',
  mlb: '#002D72',
  nhl: '#000000',
  wnba: '#FF6900',
  mls: '#013A5E',
  // NCAA / Collegiate
  ncaa: '#003DA5',
  ncaaf: '#003DA5',
  'college-football': '#003DA5',
  'mens-college-basketball': '#003DA5',
  'womens-college-basketball': '#003DA5',
  'college-baseball': '#003DA5',
  'college-softball': '#003DA5',
};

/**
 * Returns the official league logo URL for a given league or sport string.
 */
export const getLeagueLogo = (league?: string | null, sport?: string | null): string | null => {
  const key = (league || sport || '').toLowerCase().trim();
  return leagueLogoMap[key] || null;
};

/**
 * Returns the official brand color for a given league.
 */
export const getLeagueColor = (league?: string | null, sport?: string | null): string => {
  const key = (league || sport || '').toLowerCase().trim();
  return leagueColorMap[key] || '#1a1a2e';
};
